/* eslint-disable */
import { useEffect, useLayoutEffect, useCallback } from 'react';

// ============================================================
// useFitRail — the rail fits itself by MEASUREMENT, like the bar (useFitBar):
// after every render it clears the collapse classes, sums what its groups
// need against its width, and applies the steps below — least important
// first — until it fits (prototype v2's order). rF hides the least important
// remaining list filter (highest data-prio); it stays reachable in "All
// filters". Measured on the groups' own boxes, so an open popover (absolutely
// positioned) never counts as overflow.
// ============================================================

const STEPS = ['rRes', 'rF', 'rF', 'rK', 'rLbl', 'rYr', 'rGl', 'rF', 'rF', 'rF', 'rLine', 'rRes2'];

function need(rail) {
  const kids = Array.from(rail.children).filter((k) => getComputedStyle(k).display !== 'none');
  const cs = getComputedStyle(rail);
  const gap = parseFloat(cs.columnGap || cs.gap) || 8;
  let sum = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) + Math.max(0, kids.length - 1) * gap;
  for (const k of kids) {
    // a group's own content, not its box (the result group is pushed right by margin-left:auto)
    const g = getComputedStyle(k);
    const inner = Array.from(k.children).filter((c) => getComputedStyle(c).display !== 'none');
    const igap = parseFloat(g.columnGap || g.gap) || 0;
    let w = parseFloat(g.paddingLeft) + parseFloat(g.paddingRight) + parseFloat(g.borderLeftWidth) + parseFloat(g.borderRightWidth) + Math.max(0, inner.length - 1) * igap;
    for (const c of inner) w += c.getBoundingClientRect().width;
    sum += w;
  }
  return sum;
}

export function fitRail(rail, s) {
  if (!rail) return;
  STEPS.forEach((c) => s[c] && rail.classList.remove(s[c]));
  rail.querySelectorAll(`.${s.hid}`).forEach((e) => e.classList.remove(s.hid));
  const fits = () => need(rail) <= rail.clientWidth + 0.5;
  if (fits()) return;
  for (const st of STEPS) {
    if (st === 'rF') {
      const vis = Array.from(rail.querySelectorAll('[data-rail-group="filt"] > [data-ffw="list"]')).filter((e) => !e.classList.contains(s.hid));
      if (!vis.length) continue;
      vis.sort((a, b) => (+b.dataset.prio || 0) - (+a.dataset.prio || 0))[0].classList.add(s.hid);
    } else if (s[st]) rail.classList.add(s[st]);
    if (fits()) break;
  }
}

export function useFitRail(ref, s, off) {
  const run = useCallback(() => { if (!off) fitRail(ref.current, s); }, [ref, s, off]);
  useLayoutEffect(() => { run(); });
  useEffect(() => {
    if (off) return undefined;
    const on = () => run();
    window.addEventListener('resize', on);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(on).catch(() => {});
    if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', on);
    const el = ref.current;
    const ro = typeof ResizeObserver !== 'undefined' && el ? new ResizeObserver(on) : null;
    ro && ro.observe(el);
    return () => {
      window.removeEventListener('resize', on);
      if (document.fonts && document.fonts.removeEventListener) document.fonts.removeEventListener('loadingdone', on);
      ro && ro.disconnect();
    };
  }, [run, ref, off]);
  return run;
}
